import xSvg from './x.svg';
import { useState } from 'react';
import {
  zDesktopBanner,
  zCookiesBannerMoreThenIntercom,
} from '@/shared/constants/zIdxs';
import { StoredCookiesBannerWasClosed } from '@/shared/utils/Stored';
import SmartLink from '@/shared/ui/SmartLink';
import { useIsMobile } from '@/modules/use-window-width';
import { useProfile } from '@/routes/Providers/ProfileProvider';

export default function CookieBanner() {
  const isMobile = useIsMobile();
  const { profile } = useProfile();
  const [closed, setClosed] = useState(() =>
    StoredCookiesBannerWasClosed.get(),
  );

  if (closed || profile === null) {
    return null;
  }

  return (
    <div
      className="sticky bottom-0 flex items-center justify-center gap-4xl bg-(--warningDisabled) px-16 py-3xl text-center text-body-md font-medium text-gray-text max-md:flex-row-reverse max-md:items-start max-md:gap-s max-md:py-m max-md:pr-11.25 max-md:pb-2xl max-md:pl-m"
      style={{
        zIndex: isMobile ? zCookiesBannerMoreThenIntercom : zDesktopBanner,
      }}
    >
      <span>
        We use cookies to give you the best experience on our website. By using
        our services, you agree to our use of cookies and accept our{' '}
        <SmartLink
          className="mt-xs inline-block text-body-md font-regular text-gray-text underline"
          target="_blank"
          to="/terms"
        >
          Terms & Conditions
        </SmartLink>
      </span>
      <button
        type="button"
        className="btn-reset size-6 shrink-0 bg-gray-text"
        onClick={() => {
          setClosed(true);
          StoredCookiesBannerWasClosed.set();
        }}
        style={{
          mask: `url(${JSON.stringify(xSvg)}) no-repeat center`,
        }}
      />
    </div>
  );
}
